import { useCallback } from 'react';
import { compact } from 'lodash';

import { ChronicDiseaseSimple } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import {
   Badge,
   BadgePosition,
   BadgeType,
   ImportDataIcon,
   Link,
   LinkSize,
   StyledMargin,
   Tooltip,
} from '@dreryk/react-components';

import { visitDetailsTranslationKeys } from '../../../../../translations';
import { dispatchVisitDiagnosesAppendEvent } from '../../../VisitFormSynchronization.event';
import { useVisitFormSyncing } from '../../../VisitFormSynchronization.hooks';

type ChronicDiseasesCopyActionProps = {
   readonly chronicDiseases: ChronicDiseaseSimple[];
};

export const ChronicDiseasesCopyAction = (props: ChronicDiseasesCopyActionProps): JSX.Element => {
   const visitFormSyncing = useVisitFormSyncing();

   const handleClick = useCallback(() => {
      dispatchVisitDiagnosesAppendEvent(
         compact(
            props.chronicDiseases.map((chronicDisease) =>
               chronicDisease.diagnosis
                  ? {
                       code: chronicDisease.diagnosis.getCode().asString(),
                       name: chronicDisease.diagnosis.getName().asString(),
                       main: false,
                    }
                  : undefined
            )
         )
      );
   }, [props.chronicDiseases]);

   return (
      <Tooltip testId={'copyChronicDiseases'} content={visitDetailsTranslationKeys.diagnoses.copyChronicDiseases}>
         <StyledMargin right={8}>
            <Link
               testId={'copyChronicDiseases'}
               onClick={handleClick}
               size={LinkSize.BIG}
               disabled={visitFormSyncing}
               icon={
                  <Badge
                     type={BadgeType.WARNING}
                     count={props.chronicDiseases.length}
                     position={BadgePosition.TOP_RIGHT}
                     testId={'chronicDiseasesCount'}
                     compact
                  >
                     <ImportDataIcon />
                  </Badge>
               }
            />
         </StyledMargin>
      </Tooltip>
   );
};
